import { render, staticRenderFns } from "./ShiftDialog.vue?vue&type=template&id=b9f3d556"
import script from "./ShiftDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShiftDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports